/*
 *
 * CheckoutStep1Page constants
 *
 */

enum ActionTypes {
  DEFAULT_ACTION = 'app/CheckoutStep1Page/DEFAULT_ACTION',
  REMOVE_ALL_PRODUCT = 'app/CheckoutStep1Page/REMOVE_ALL_PRODUCT',
  REMOVE_ALL_NOT_AVAILABLE_PRODUCTS = 'app/CheckoutStep1Page/REMOVE_ALL_NOT_AVAILABLE_PRODUCTS',
}

export default ActionTypes;
